import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

export const StyledBox = styled(Box)(
  ({ theme, $borderWidth, borderRadius, padding, backgroundColor, $backgroundImage }) => `
    box-shadow: ${theme.DS_shadows.priceCard};
    background-color: ${backgroundColor};
    padding: ${padding};
    borderRadius: ${borderRadius};
    border: ${$borderWidth} solid ${theme.DS_palette.border.light};
     background-image: ${$backgroundImage ? `${$backgroundImage}` : 'none'}

   `,
);
